module.exports = __webpack_public_path__ + "static/img/photo-02.b5823cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides_photo/photo-02.jpg
// module id = q4pY
// module chunks = 0